( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'treatment-builder-cta', COMPONENT );
} )( app );
